import { render, staticRenderFns } from "./Sidebardocuments.vue?vue&type=template&id=370d8366&"
import script from "./Sidebardocuments.vue?vue&type=script&lang=js&"
export * from "./Sidebardocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports